<template>
  <div class="container-fluid">
    <div class="our-workers">
      <h3 class="mb-3">المقترضين</h3>
      <div class="locations__header d-flex">
        <div style="flex: 1">
          <el-input
            @input="filterInJobs"
            prefix-icon="el-icon-search"
            placeholder="بحث في المقترضين"
            v-model="search"
          ></el-input>
        </div>

        <div>
          <el-button type="primary" @click="addUserModel = true">
            إضافة
          </el-button>
        </div>
      </div>

      <!-- <div class="workers-header d-flex mt-2">
        <div>
          <h3 class="mt-2">المقترضين</h3>
        </div>
        <div class="d-flex mt-2" style="gap: 10px">
          <div>
            <el-input
              @keyup.enter.native="filterInJobs"
              prefix-icon="el-icon-search"
              placeholder="بحث في المقترضين"
              v-model="search"
            ></el-input>
          </div>
          <div>
            <el-select
              v-model="selectedJob"
              @change="filterInJobs()"
              placeholder="بحث بالحرفة"
              style="width: 100% !important"
              clearable
            >
              <el-option
                v-for="item in jobs"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button @click="addUserModel = true">إضافة</el-button>
          </div>
        </div>
      </div> -->

      <div class="mt-4">
        <div class="user">
          <el-table :data="workers" class="table-mobile" style="width: 100%">
            <el-table-column
              type="index"
              label="#"
              class-name="display-mobile-none"
            />
            <el-table-column prop="name" label="الإسم">
              <template slot-scope="scope">
                <span class="label"> {{ scope.$index + 1 }} # الإسم</span>
                <div>{{ scope.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="الهاتف">
              <template slot-scope="scope">
                <span class="label">الهاتف</span>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="العنوان">
              <template slot-scope="scope">
                <span class="label">العنوان</span>
                <div>{{ scope.row.address }}</div>
              </template>
            </el-table-column>
            <el-table-column label="عدد السلف">
              <template slot-scope="scope">
                <span class="label">عدد السلف</span>
                <div>
                  {{ scope.row.borrower_deals.length }}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="balance" label="المبلغ"> </el-table-column> -->
            <el-table-column label="التفاصيل">
              <template slot-scope="scope">
                <el-row type="flex" justify="center">
                  <el-col :span="12">
                    <el-button @click="goToWorkerDetail(scope.row)">
                      عرض التفاصيل
                    </el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                      style="margin: 0 10px; padding: 6px"
                      @click="
                        (updateUserModel = true), (updateUser = { ...scope.row })
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Icon"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <rect
                          id="Area"
                          width="20"
                          height="20"
                          fill="#fcfcfc"
                          opacity="0"
                        />
                        <g
                          id="Icon-2"
                          data-name="Icon"
                          transform="translate(1.566 1.566)"
                        >
                          <path
                            id="Path"
                            d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                            transform="translate(0.101 -1.566)"
                            fill="none"
                            stroke="#919efa"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.667"
                          />
                          <path
                            id="Path-2"
                            data-name="Path"
                            d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                            transform="translate(-6.667 -1.566)"
                            fill="none"
                            stroke="#919efa"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.667"
                          />
                        </g>
                      </svg>
                    </el-button>
                  </el-col>
                </el-row>

              </template>
            </el-table-column>

            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="row">
                  <div
                    class="col-md-4 mb-2"
                    v-for="deal in props.row.worker_deals"
                    :key="deal.id"
                  >
                    <div class="project-deal">
                      <table>
                        <tr>
                          <td>الوصف</td>
                          <td>{{ deal.description }}</td>
                        </tr>
                        <tr>
                          <td>المبلغ الكلي</td>
                          <td>{{ deal.amount }}</td>
                        </tr>
                        <tr>
                          <td>المبلغ المدفوع</td>
                          <td>{{ deal.paied }}</td>
                        </tr>
                        <tr>
                          <td>التاريخ</td>
                          <td>{{ $moment(deal.created_at).format("llll") }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة مقترض"
      :active.sync="addUserModel"
    >
      <div class="popup-calender">
        <el-form :model="addUser" ref="addUser">
          <h6 class="mb-1">الاسم</h6>
          <el-form-item
            prop="name"
            :rules="[{ required: true, message: 'الاسم مطلوب' }]"
          >
            <el-input placeholder="الاسم" v-model="addUser.name"></el-input>
          </el-form-item>

          <h6 class="mb-1">التليفون</h6>
          <el-form-item
            prop="phone"
            :rules="[{ required: true, message: 'الموبايل مطلوب' }]"
          >
            <el-input placeholder="الموبايل" v-model="addUser.phone"></el-input>
          </el-form-item>

          <h6 class="mb-1">العنوان</h6>
          <el-form-item prop="address">
            <el-input
              placeholder="العنوان"
              v-model="addUser.address"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addUser')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title=" تعديل بيانات المقترض"
      :active.sync="updateUserModel"
    >
      <div class="popup-calender">
        <el-form :model="updateUser" ref="updateUser">
          <h6 class="mb-1">الاسم</h6>
          <el-form-item
            prop="name"
            :rules="[{ required: true, message: 'الاسم مطلوب' }]"
          >
            <el-input placeholder="الاسم" v-model="updateUser.name"></el-input>
          </el-form-item>

          <h6 class="mb-1">التليفون</h6>
          <el-form-item
            prop="phone"
            :rules="[{ required: true, message: 'الموبايل مطلوب' }]"
          >
            <el-input
              placeholder="الموبايل"
              v-model="updateUser.phone"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">العنوان</h6>
          <el-form-item prop="address">
            <el-input
              placeholder="العنوان"
              v-model="updateUser.address"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmitUpdate('updateUser')">
                حفظ التعديلات
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
export default {
  data() {
    return {
      updateUser: {},
      updateUserModel: false,
      search: "",
      workers: [],
      addUser: {},
      addUserModel: false,
      allWorkers: [],

      selectedJob: "",
    };
  },
  created() {
    this.getAllBorrowers();
  },
  methods: {
    goToWorkerDetail(worker) {
      localStorage.setItem("currWorker", JSON.stringify(worker));
      this.$router.push(`/borrower/${worker.id}`);
    },

    filterInJobs() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.workers = this.allWorkers.filter((ele) => {
        if (this.search && this.selectedJob) {
          return (
            ele.name.includes(this.search) && ele.job_id == this.selectedJob
          );
        } else if (!this.search && this.selectedJob) {
          return ele.job_id == this.selectedJob;
        } else if (!this.selectedJob && this.search) {
          return ele.name.includes(this.search);
        } else {
          return this.allWorkers;
        }
      });

      // loading.close();
    },
    getAllBorrowers() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/borrowers")
        .then((res) => {
          this.workers = res.data;
          this.allWorkers = res.data;
        })
        .finally(() => loading.close());
    },

    onSubmitUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });

          axiosApi
            .put(`/borrowers/${this.updateUser.id}`, this.updateUser)
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم التعديل بنجاح",
              });
              this.updateUser = {};
              this.updateUserModel = false;
              this.getAllBorrowers();
            })
            .catch((err) => {
              if (err.response.status == 500) {
                this.$vs.notify({
                  title: " عذرا",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }

              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذا الحرفي الاسم / الهاتف / التليفون موجود من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/borrowers`, this.addUser)
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الاضافة بنجاح",
              });
              this.addUser = {};
              this.addUserModel = false;
              this.getAllBorrowers();
            })
            .catch((err) => {
              if (err.response.status == 500) {
                this.$vs.notify({
                  title: " عذرا",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }

              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذا الحرفي الاسم / الهاتف / التليفون موجود من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
  },
};
</script>

<style lang="scss">
.our-workers {
  padding: 10px;
  .workers-header {
    justify-content: space-between;
  }
  .user {
    background: #f7f7f759;
    padding: 15px;
    border-radius: 10px;
  }
  .head {
    gap: 10px;
    svg {
      padding: 5px;
      background-color: rgba(var(--vs-primary), 0.3) !important;
      border-radius: 5px;
      path {
        fill: #fff;
      }
    }
  }

  // .user {
  //   td {
  //     text-align: center !important;
  //   }
  // }

  .project-deal {
    table {
      padding: 10px;
      background: #f7f7f7;
      width: 100%;
    }
  }

  .el-table .cell {
    text-align: center !important;
    padding: 10px;
    div {
      text-align: center !important;
    }
  }
}
</style>
